module.exports = __webpack_public_path__ + "static/img/user.10abde38.png";